import React from 'react';
import { Link } from 'react-router-dom';
import { formatInternationalDisplay } from '../utils/phoneCanonical';

/**
 * Internal linking block: nearby numbers in the same country/prefix range.
 */
function AdjacentNumbers({ currentId, adjacent }) {
  if (!adjacent?.length) return null;

  return (
    <section className="mt-8 p-6 bg-white rounded-lg shadow">
      <h2 className="text-lg font-semibold mb-2">Nearby numbers</h2>
      <p className="text-sm text-gray-600 mb-4">
        Similar numbers in the same region — useful if you misdialed or received calls from a
        nearby line.
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {adjacent.map((item) => (
          <li key={item.canonicalId}>
            <Link
              to={`/number/${item.canonicalId}`}
              className="flex justify-between items-center p-3 rounded border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition"
            >
              <span className="font-medium text-blue-700">
                {formatInternationalDisplay(item) || `+${item.canonicalId}`}
              </span>
              <span className="text-xs text-gray-500">
                {item.totalReports > 0
                  ? `${item.totalReports} report${item.totalReports === 1 ? '' : 's'}`
                  : 'No reports yet'}
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <p className="text-xs text-gray-400 mt-3">
        Every number has its own page for community reports and caller information.
      </p>
    </section>
  );
}

export default AdjacentNumbers;
